// Register the player service worker for offline asset/app caching.
// Only player pages set window.WEBCY_PLAYER (see _layoutScreen.cshtml), so the worker is never
// installed for the dashboard/editor. It is served from the site root for a '/' scope.
if ('serviceWorker' in navigator && window.WEBCY_PLAYER) {
    window.addEventListener('load', () => {
        // Remove the previous worker that was scoped to /js/ (it cached the bundle cache-first).
        navigator.serviceWorker.getRegistrations().then(regs => {
            regs.forEach(r => { if (r.scope && r.scope.endsWith('/js/')) r.unregister(); });
        }).catch(() => {});

        // A player app with its own on-disk asset cache (WebcyPlayer) says so through its preload
        // bridge. The worker then leaves /api/assets/data to it, rather than keeping a second copy
        // that answers first and hides every request from the app's cache. Pages and the app
        // shell are still cached, so the player still starts offline.
        var nativeAssetCache = !!(window.webcyPlayer && window.webcyPlayer.nativeAssetCache);
        var script = nativeAssetCache ? '/sw.js?nativeAssetCache=1' : '/sw.js';

        navigator.serviceWorker.register(script, { scope: '/', updateViaCache: 'none' })
            .then(registration => {
                console.log('ServiceWorker registered with scope:', registration.scope);
            })
            .catch(error => {
                console.log('ServiceWorker registration failed:', error);
            });
    });
}
